import { jsx as o, jsxs as i } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import { useMultiStyleConfig as d, chakra as h } from "@chakra-ui/react";
import { SharedFooterStylesProvider as l } from "./SharedFooter.context.es.js";
import { SharedFooterLogo as p } from "./components/SharedFooterLogo.es.js";
import { SharedFooterPlatforms as S } from "./components/SharedFooterPlatforms.es.js";
const g = a(
  ({ variant: e, size: t, orientation: m, ...s }, f) => {
    const r = d("SharedFooter", { variant: e, size: t, orientation: m });
    return /* @__PURE__ */ o(l, { value: r, children: /* @__PURE__ */ i(h.footer, { __css: r.root, ref: f, ...s, children: [
      /* @__PURE__ */ o(p, {}),
      /* @__PURE__ */ o(S, {})
    ] }) });
  }
);
export {
  g as SharedFooter
};
//# sourceMappingURL=SharedFooter.es.js.map
